import { Component, OnInit } from '@angular/core';
import { RouterModule, RouterOutlet } from '@angular/router';
import { LayoutComponent } from "./layout/layout.component";
import { Auth0Service } from './auth/service/auth0.service';
import { initRefreshTokenChecker } from './auth/utils/token-polling.utils';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, RouterModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
  constructor(private auth : Auth0Service) {

  }
  ngOnInit(): void {
      initRefreshTokenChecker(this.auth);
  }
}
